// commonSlice.js
import { createSlice } from '@reduxjs/toolkit';

const commonSlice = createSlice({
  name: 'common',
  initialState: {
    isLoading: false,
    jobId: null,
    userId: null,
    userLocation: {
      lat: null,
      long: null
    }
  },
  reducers: {
    setLoader: (state, action) => {
      state.isLoading = action.payload
    },
    setJobId: (state, action) => {
      state.jobId = action.payload
    },
    setUserId: (state, action) => {
      state.userId = action.payload
    },
    setUserLocation: (state, action) => {
      state.userLocation = {
        lat : action.payload?.lat,
        long : action.payload?.long
      }
    },
    clearUserLocation: (state, action) => {
      state.userLocation = {
        lat : null,
        long : null
      }
    }
  },
});

export const { setLoader, setJobId, setUserId, setUserLocation,clearUserLocation } = commonSlice.actions;
export const isLoading = (state) => state.common.isLoading;
export const jobId = (state) => state.common.jobId;
export const userId = (state) => state.common.userId;
export const userLocation = (state) => state.common.userLocation;
export default commonSlice.reducer;
